export type SearchParamValue = string | null | undefined;

/**
 * Replaces the query parameters owned by one page while preserving shell-level
 * and cross-cutting parameters such as orgId and embed.
 */
export const replaceOwnedSearchParams = (
  current: URLSearchParams,
  ownedKeys: readonly string[],
  values: Readonly<Record<string, SearchParamValue>>
): URLSearchParams => {
  const next = new URLSearchParams(current);

  ownedKeys.forEach((key) => next.delete(key));
  Object.entries(values).forEach(([key, value]) => {
    if (value != null && value !== '') {
      next.set(key, value);
    }
  });

  return next;
};
